"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAddOnClickToATagsMiddleware = createAddOnClickToATagsMiddleware;
exports.createRenderMiddleware = createRenderMiddleware;
exports.createUpdateTagsMiddleware = createUpdateTagsMiddleware;
exports["default"] = createMiddlewares;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("../common/utils");
var _middlewares = _interopRequireDefault(require("../common/middlewares"));
var _excluded = ["log"];
var style = require("./../common/template/template_css.js")["default"];
function createRenderMiddleware() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  function defaultRenderHandle(_x, _x2, _x3) {
    return _defaultRenderHandle.apply(this, arguments);
  }
  function _defaultRenderHandle() {
    _defaultRenderHandle = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee(req, res, next) {
      var wappResponse;
      return (0, _regenerator2["default"])().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            wappResponse = res.wappResponse;
            if (wappResponse.content && !wappResponse.content.renderType) {
              res.wappResponse.status(wappResponse.statusCode || 200);
              res.wappResponse.send(renderMiddleware.render({
                wapp: wapp,
                req: req,
                res: res
              }));
              next();
            } else {
              next();
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _defaultRenderHandle.apply(this, arguments);
  }
  function defaultHandle(_x4, _x5, _x6) {
    return _defaultHandle.apply(this, arguments);
  }
  function _defaultHandle() {
    _defaultHandle = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee4(req, res, out) {
      var renderMiddlewares, index, next, _next;
      return (0, _regenerator2["default"])().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _next = function _next3() {
              _next = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(err) {
                var func;
                return (0, _regenerator2["default"])().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      if (!renderMiddlewares[index]) {
                        _context3.n = 2;
                        break;
                      }
                      func = renderMiddlewares[index];
                      index = index + 1;
                      _context3.n = 1;
                      return func(req, res, err ? /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2() {
                        return (0, _regenerator2["default"])().w(function (_context2) {
                          while (1) switch (_context2.n) {
                            case 0:
                              _context2.n = 1;
                              return next(err);
                            case 1:
                              return _context2.a(2);
                          }
                        }, _callee2);
                      })) : next);
                    case 1:
                      return _context3.a(2, _context3.v);
                    case 2:
                      if (!(typeof out === "function")) {
                        _context3.n = 4;
                        break;
                      }
                      index = 0;
                      _context3.n = 3;
                      return out(err);
                    case 3:
                      return _context3.a(2, _context3.v);
                    case 4:
                      return _context3.a(2, null);
                  }
                }, _callee3);
              }));
              return _next.apply(this, arguments);
            };
            next = function _next2(_x7) {
              return _next.apply(this, arguments);
            };
            renderMiddlewares = Object.keys(renderMiddleware.handles).map(function (key) {
              return renderMiddleware.handles[key];
            });
            index = 0;
            _context4.n = 1;
            return next();
          case 1:
            return _context4.a(2, _context4.v);
        }
      }, _callee4);
    }));
    return _defaultHandle.apply(this, arguments);
  }
  function defaultRender(_ref) {
    var wapp = _ref.wapp,
      req = _ref.req,
      res = _ref.res;
    var wappResponse = res.wappResponse;
    var _wappResponse$content = wappResponse.content,
      content = _wappResponse$content === void 0 ? {} : _wappResponse$content;
    var _content$render = content.render,
      render = _content$render === void 0 ? "" : _content$render;
    if (typeof render === "function") {
      render = render({
        wapp: wapp,
        req: req,
        res: res
      });
    }
    wapp.styles.use(style);
    return render;
  }
  function defaultAddHandle(obj) {
    if (typeof obj === "object" && !obj.length) {
      Object.keys(obj).forEach(function (handleName) {
        var handle = obj[handleName];
        if (typeof handle == "function") {
          renderMiddleware.handles[handleName] = handle;
        }
      });
    }
  }
  var renderMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    handles: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: {
        render: defaultRenderHandle
      }
    }),
    render: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultRender
    }),
    addHandle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultAddHandle
    })
  });
  function renderMiddleware(req, res, next) {
    if (typeof renderMiddleware.handle === "function") {
      renderMiddleware.handle(req, res, next);
    }
    return renderMiddleware;
  }
  (0, _utils.mergeProperties)(renderMiddleware, renderMiddlewareProperties);
  Object.defineProperty(renderMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  return renderMiddleware;
}
function createUpdateTagsMiddleware() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  function defaultHandle(req, res, next) {
    if (res.wappResponse.sended) {
      var updateTag = function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
        var node = document.head.querySelector("".concat(tagName, "[").concat(keyName, "=\"").concat(keyValue, "\"]"));
        if (node && node.getAttribute(attrName) === attrValue) {
          return;
        }
        if (node) {
          node.parentNode.removeChild(node);
        }
        if (typeof attrValue === "string") {
          var nextNode = document.createElement(tagName);
          nextNode.setAttribute(keyName, keyValue);
          nextNode.setAttribute(attrName, attrValue);
          document.head.appendChild(nextNode);
        }
      };
      var updateMeta = function updateMeta(name, content) {
        updateTag("meta", "name", name, "content", content);
      };
      var config = wapp.client.config;
      var _config$siteName = config.siteName,
        siteName = _config$siteName === void 0 ? "Wapplr" : _config$siteName;
      var _res$wappResponse = res.wappResponse,
        _res$wappResponse$con = _res$wappResponse.content,
        content = _res$wappResponse$con === void 0 ? {} : _res$wappResponse$con,
        statusCode = _res$wappResponse.statusCode;
      var _content$title = content.title,
        title = _content$title === void 0 ? "" : _content$title,
        _content$description = content.description,
        description = _content$description === void 0 ? "" : _content$description,
        _content$author = content.author,
        author = _content$author === void 0 ? "" : _content$author;
      if (typeof title === "function") {
        title = title({
          wapp: wapp,
          req: req,
          res: res
        });
      }
      title = "".concat(title ? title : statusCode === 404 ? "Not Found | " + siteName : "Untitled Page | " + siteName);
      if (typeof description === "function") {
        description = description({
          wapp: wapp,
          req: req,
          res: res
        });
      }
      description = description ? description : title && title.split ? title.split(" | ")[0] : title;
      if (typeof author === "function") {
        author = author({
          wapp: wapp,
          req: req,
          res: res
        });
      }
      author = author || siteName;
      document.title = title;
      updateMeta("description", description);
      updateMeta("author", author);
    }
    next();
  }
  var tagsMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    })
  });
  function tagsMiddleware(req, res, next) {
    if (typeof tagsMiddleware.handle === "function") {
      tagsMiddleware.handle(req, res, next);
    }
    return tagsMiddleware;
  }
  (0, _utils.mergeProperties)(tagsMiddleware, tagsMiddlewareProperties);
  Object.defineProperty(tagsMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  return tagsMiddleware;
}
function createAddOnClickToATagsMiddleware() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  function defaultHandle(req, res, next) {
    if (res.wappResponse.sended) {
      var tags = document.querySelectorAll("a");
      Array.prototype.map.call(tags, function (tag) {
        var href = tag.getAttribute("href");
        var target = tag.getAttribute("target");
        var enable = typeof tag.getAttribute("wapplronclicklistener") == "string";
        if (target === "_blank" || href && href.slice(0, 7) === "http://" || href && href.slice(0, 8) === "https://") {} else {
          if (!tag._onclickListener && enable) {
            tag._onclickListener = function (e) {
              e.preventDefault();
              wapp.client.history.push((0, _objectSpread2["default"])({
                search: "",
                href: ""
              }, wapp.client.history.parsePath(href)));
            };
            tag.addEventListener("click", tag._onclickListener, false);
            tag.removeAttribute("wapplronclicklistener");
          }
        }
      });
    }
    next();
  }
  var onClickMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    })
  });
  function onClickMiddleware(req, res, next) {
    if (typeof onClickMiddleware.handle === "function") {
      onClickMiddleware.handle(req, res, next);
    }
    return onClickMiddleware;
  }
  (0, _utils.mergeProperties)(onClickMiddleware, onClickMiddlewareProperties);
  Object.defineProperty(onClickMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  return onClickMiddleware;
}
function createMiddlewares(p) {
  var _commonMiddlewares = (0, _middlewares["default"])(p),
    log = _commonMiddlewares.log,
    rest = (0, _objectWithoutProperties2["default"])(_commonMiddlewares, _excluded);
  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, rest), {}, {
    render: createRenderMiddleware(p),
    tags: createUpdateTagsMiddleware(p),
    onClick: createAddOnClickToATagsMiddleware(p),
    log: log
  });
}